
import auth from './modules/auth'

export default {
    auth
}